// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30LWh","icon":"styles_icon__1BkjS"};